// extracted by mini-css-extract-plugin
export default {"widget":"widget--aXZfK","container":"container--qR2lq"};